import React from 'react'

import { Input } from '@components/Input'

import { GridTextFieldModel } from '@types'

import { truncateWithEllipsis } from '@utils/string'

import {
  GridContainer,
  GridWrapper,
  HeaderCell,
  RowLabel,
  DataCell,
  PreviewContainer,
  PreviewLabel,
  PreviewContent,
  PreviewItem,
} from './SubmitterFieldGridText.styled'

type SubmitterFieldGridTextProps = {
  field: GridTextFieldModel
  disabled?: boolean
  isPreview?: boolean
  onChange: (updates: Partial<GridTextFieldModel>) => void
}

export const SubmitterFieldGridText: React.FC<SubmitterFieldGridTextProps> = ({
  field,
  disabled = false,
  isPreview = false,
  onChange,
}: SubmitterFieldGridTextProps) => {
  const handleCellChange = (rowIndex: number, colIndex: number, value: string) => {
    const updatedRows = field.rows.map((row, ri) => {
      if (ri !== rowIndex) return row
      const updatedColumns = row.columns.map((col, ci) => {
        if (ci !== colIndex) return col
        return { ...col, value }
      })
      return { ...row, columns: updatedColumns }
    })
    onChange({ rows: updatedRows })
  }

  if (isPreview) {
    const firstRow = field.rows[0]

    if (!firstRow) {
      return <PreviewContainer>{'Grid'}</PreviewContainer>
    }

    return (
      <PreviewContainer>
        <PreviewLabel>{truncateWithEllipsis(firstRow.label, 20)}</PreviewLabel>
        <PreviewContent>
          {firstRow.columns.slice(0, 4).map((column) => (
            <PreviewItem key={column.id}>
              {column.label && <span className="column-label">{column.label}</span>}
            </PreviewItem>
          ))}
        </PreviewContent>
      </PreviewContainer>
    )
  }

  const columnCount = field.rows[0]?.columns.length + 1

  return (
    <GridContainer>
      <GridWrapper columnsCount={columnCount}>
        <HeaderCell className="first-cell" />

        {field.rows[0]?.columns.map((column) => (
          <HeaderCell key={column.id}>{column.label || '-'}</HeaderCell>
        ))}

        {field.rows.map((row, rowIndex) => (
          <React.Fragment key={row.id}>
            <RowLabel>
              <span>{row.label || '-'}</span>
            </RowLabel>
            {row.columns.map((column, colIndex) => (
              <DataCell key={column.id}>
                <Input
                  label=""
                  type="text"
                  hideOptional
                  disabled={disabled}
                  value={column.value || ''}
                  required={column.required}
                  onChange={(value) => handleCellChange(rowIndex, colIndex, value)}
                />
              </DataCell>
            ))}
          </React.Fragment>
        ))}
      </GridWrapper>
    </GridContainer>
  )
}
